import React, { useRef } from 'react';
import DownloadPdfButton from '../../../common/download-pdf-button/DownloadPdfButton';
import './ttd.css';

const Ttd = () => {
    const contentRef = useRef(null);

    return (
        <div className="pdf-page-wrapper">
            <DownloadPdfButton contentRef={contentRef} filename="ttd-guide" />
            <div className="ttd-container" ref={contentRef}>
            <p className="ttd-title-headline">Accepting a Deal Pushed to Your TTD Seat</p>

            <p className="ttd-sub-title-headline">● Navigate to the Proposals Section:</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">Go to <b>Inventory &gt; Proposals</b> in your TTD account.</li>
                <li className="ttd-outline-bullet">In the <b>Proposals</b> section, you can view any deals that have been pushed to your seat account.</li>
            </ul>

            <p className="ttd-sub-title-headline">● Activating the Proposal Option:</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">If the "Proposal" option is not yet activated in your account, you will need to enable it.
                </li>
                <li className="ttd-outline-bullet">To do this, contact your TTD account representative and request the activation of the "Proposal" feature.
                </li>
            </ul>

            <p className="ttd-sub-title-headline">● Viewing Deal Details:</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">Once activated, you’ll be able to access and view all the deal details within your account.</li>
                <li className="ttd-outline-bullet">This allows you to review any deals that have been pushed to your seat, making it easier to manage and track those deals.</li>
            </ul>

            <p className="ttd-title-headline">Creating a First-Party Contract or PMP in TTD:</p>

            <p className="ttd-sub-title-headline">● Start by Creating a New First-Party Contract:</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">Go to <b>Inventory &gt; First-Party Contracts &gt; New Contract</b>.</li>
                <li className="ttd-outline-bullet">Here, you’ll enter the key details for your new contract, such as:
                </li>
                <ul className="ttd-square-list">
                    <li className="ttd-square-bullet"><b>Name:</b> The name of the contract or deal.</li>
                    <li className="ttd-square-bullet"><b>Start Date:</b> When the contract will begin.</li>
                    <li className="ttd-square-bullet"><b>Deal ID:</b> Unique identifier for the deal.</li>
                    <li className="ttd-square-bullet"><b>Floor CPM:</b></li>
                    <li className="ttd-square-bullet"><b>Exchange:</b> he ad exchange through which you will buy or sell inventory.</li>
                    <li className="ttd-square-bullet"><b>Delivery Profile:</b>This is the group or category to which the deal will be assigned.</li>
                </ul>
            </ul>

            <p className="ttd-sub-title-headline">● Creating a Delivery Profile (Optional but Recommended):</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">To create a <b>Delivery Profile</b>, go to <b>Inventory &gt; First-Party Contracts &gt; Create Delivery Profile</b>.</li>
                <li className="ttd-outline-bullet">This step allows you to set the profile for delivery, such as the targeting criteria and how the deal’s inventory is managed and delivered.
                </li>
            </ul>

            <p className="ttd-sub-title-headline">● Completing the Contract Setup:</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">Once all required fields are filled out, you can select <b>Complete</b> to finalize the contract.</li>
                <li className="ttd-outline-bullet">While TTD doesn’t require you to fill in every detail, it’s recommended to input as much information as possible to ensure the deal is well-defined.
                </li>
            </ul>

            <p className="ttd-title-headline">Creating a Programmatic Guaranteed (PG) Deal in TTD:</p>

            <p className="ttd-sub-title-headline">● Initiating the PG Deal Setup:</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">Navigate to <b>Inventory &gt; More Contract Actions &gt; Programmatic Guaranteed</b>.</li>
                <li className="ttd-outline-bullet">This option allows you to set up a programmatic guaranteed deal, which is a type of deal that guarantees a certain amount of inventory at a fixed CPM rate.
                </li>
            </ul>

            <p className="ttd-sub-title-headline">● Entering PG Deal Details:</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">You’ll need to fill in the following details for the PG deal:
                </li>
                <ul className="ttd-square-list">
                    <li className="ttd-square-bullet"><b>Delivery Profile:</b> This is where the deal’s inventory and targeting settings are defined.</li>
                    <li className="ttd-square-bullet"><b>Contract Name:</b> The name of the PG deal.</li>
                    <li className="ttd-square-bullet"><b>Supply Vendor:</b> The ad exchange or supply side platform (SSP) providing the inventory.
                    </li>
                    <li className="ttd-square-bullet"><b>Deal ID:</b> The unique identifier for this PG deal.</li>
                    <li className="ttd-square-bullet"><b>Media Type:</b> The type of media being purchased (e.g., display, video).</li>
                    <li className="ttd-square-bullet"><b>Budget:</b> The overall budget allocated for the PG deal.


                    </li>
                    <li className="ttd-square-bullet"><b>Flights:</b>  The duration or time periods for which the deal will run (e.g., specific campaign dates).
                    </li>
                    <li className="ttd-square-bullet"><b>CPM:</b></li>
                </ul>
            </ul>

            <p className="ttd-sub-title-headline">● Finalizing the PG Deal</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet">After entering all the relevant information, click <b>Save</b>.</li>
                <li className="ttd-outline-bullet">YOnce the PG deal is saved, you can proceed to <b>add creatives</b> to the deal or simply save it and create the campaign at a later time.</li>
            </ul>

            <p className="ttd-title-headline">Summary</p>
            <ul className="ttd-list">
                <li className="ttd-outline-bullet"><b>Accepting a Deal:</b> Use the "Proposals" section to view and accept deals pushed to your seat account.</li>
                <li className="ttd-outline-bullet"><b>Creating a PMP:</b> Input essential details like the contract name, deal ID, floor CPM, and delivery profile.</li>
                <li className="ttd-outline-bullet"><b>Creating a PG Deal:</b> Set up a programmatic guaranteed deal by specifying all relevant deal information, such as media type, supply vendor, and budget.
                </li>
            </ul>

            <p className="ttd-text">

                By following these steps, you can effectively manage deals in The Trade Desk, ensuring smooth deal creation and setup.
            </p>

            </div>
        </div>
    );
}

export default Ttd;
